/**
 * Drag + momentum scroll for featured thumbnails in mobile menu
 * Enables touch-based horizontal scrolling with momentum for menu drawer content lists
 */
document.addEventListener('DOMContentLoaded', function () {
  var lists = document.querySelectorAll(
    'header-drawer .menu-drawer__featured-content-list'
  );

  lists.forEach(function (list) {
    var isDragging = false;
    var startX = 0;
    var startScrollLeft = 0;
    var lastX = 0;
    var lastTime = 0;
    var velocity = 0;
    var momentumId = null;

    function stopMomentum() {
      if (momentumId !== null) {
        cancelAnimationFrame(momentumId);
        momentumId = null;
      }
    }

    function startMomentumScroll() {
      // If velocity is tiny, don't bother
      if (Math.abs(velocity) < 0.01) return;

      var amplitude = velocity * 300; // tweak this for more/less throw
      var target = list.scrollLeft - amplitude;
      var timeConstant = 325; // ms
      var start = performance.now();
      var scrollStart = list.scrollLeft;

      function step() {
        var elapsed = performance.now() - start;
        var delta = amplitude * Math.exp(-elapsed / timeConstant);
        var newScrollLeft = scrollStart - (amplitude - delta);

        if (Math.abs(delta) > 0.5) {
          list.scrollLeft = newScrollLeft;
          momentumId = requestAnimationFrame(step);
        } else {
          momentumId = null;
        }
      }

      momentumId = requestAnimationFrame(step);
    }

    list.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        stopMomentum();
        isDragging = true;
        var touch = e.touches[0];
        startX = touch.pageX;
        lastX = touch.pageX;
        startScrollLeft = list.scrollLeft;
        lastTime = performance.now();
      },
      { passive: false, capture: true }
    );

    list.addEventListener(
      'touchmove',
      function (e) {
        if (!isDragging || !e.touches || e.touches.length !== 1) return;
        var touch = e.touches[0];
        var x = touch.pageX;
        var now = performance.now();

        var dx = x - lastX;
        var dt = now - lastTime || 16;

        // Move the list opposite to finger movement
        list.scrollLeft -= dx;

        // Velocity in px/ms
        velocity = dx / dt;

        lastX = x;
        lastTime = now;

        e.preventDefault();   // stop page scroll
        e.stopPropagation();  // keep drawer from stealing event
      },
      { passive: false, capture: true }
    );

    list.addEventListener(
      'touchend',
      function () {
        if (isDragging) {
          isDragging = false;
          startMomentumScroll();
        }
      },
      { capture: true }
    );

    list.addEventListener(
      'touchcancel',
      function () {
        isDragging = false;
        stopMomentum();
      },
      { capture: true }
    );
  });
});
